module.exports = __webpack_public_path__ + "img/KLT.f4f60a20.jpg";